import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EnvConfigurationService } from './envconf.service';
import { ApiService } from './api.service';
import { UserInfos } from '../models/userInfos';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  endpoint = `${EnvConfigurationService.configuration.BACKEND_URL}${EnvConfigurationService.configuration.BACKEND_SUB_PATH}/user`;

  /**
   * Constructor
   *
   * @param http httpClient
   *  @param apiService apiService
   */
  constructor(private readonly http: HttpClient, private readonly apiService: ApiService) {}


  /**
   * Get all Sites by customer PK and name search
   *
   */
  getUserInfos(userId:string): Observable<UserInfos> {
    return this.http.get<UserInfos>(`${this.endpoint}/infos`);
  }

}
